// extracted by css-extract-rspack-plugin
export default {"basicInfoBox":"basicInfoBox-nPYpIJ","ellipsis":"ellipsis-xLolGK"};